import { PartyTypeCode } from '../../consts/party-type-code.enum';
import { OwnerAddressModel } from './owner-address.model';

export class OwnerModel {

  nip?: string;
  pesel?: string;
  lastName?: string;
  firstName?: string;
  birthDate: Date;
  companyName?: string;
  partyTypeCode?: string;
  address?: OwnerAddressModel;
  drivingLicenseIssueYear?: number;
  drivingLicenseIssueMonth?: number;
  matrimonialStatus?: string;
  childrenUnder26?: boolean;
  oldestYoungChildYearOfBirth?: number;

  constructor() {

    this.partyTypeCode = PartyTypeCode.NATURAL_PERSON;
    this.address = new OwnerAddressModel();

    this.nip = null;
    this.companyName = null;
  }
}
